import React from "react";

const TvFavoriteIcon = ({ isFavorite = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g>
        <path
          d="M5.5 0C2.46243 0 0 2.46245 0 5.5C0 11 6.5 16 10 17.1631C13.5 16 20 11 20 5.5C20 2.46245 17.5375 0 14.5 0C12.6398 0 10.9953 0.92345 10 2.3369C9.00465 0.92345 7.36015 0 5.5 0Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 2 4)"
          fill={isFavorite ? "rgb(250, 94, 31)" : "transparent"}
        />
        <path
          d="M5.5 1Q4.58382 1 3.74871 1.35322Q2.94133 1.69472 2.31802 2.31802Q1.69472 2.94133 1.35322 3.74871Q1 4.58382 1 5.5Q1 7.20038 1.95502 9.01297Q2.82668 10.6673 4.39808 12.2543Q5.80752 13.6776 7.50712 14.7858Q9.05563 15.7955 10.3154 16.2141L10 17.1631L9.68464 16.2141Q10.9444 15.7955 12.4929 14.7858Q14.1925 13.6776 15.6019 12.2543Q17.1733 10.6673 18.045 9.01297Q19 7.20038 19 5.5Q19 4.58382 18.6468 3.74871Q18.3053 2.94133 17.682 2.31803Q17.0587 1.69472 16.2513 1.35322Q15.4162 1 14.5 1Q13.3777 1 12.3944 1.52176Q11.4407 2.02778 10.8176 2.91266Q10.7609 2.99319 10.6896 3.06111Q10.6182 3.12903 10.535 3.18172Q10.4518 3.23442 10.3599 3.26987Q10.2681 3.30532 10.171 3.32217Q10.074 3.33901 9.97551 3.3366Q9.87705 3.33419 9.78095 3.31261Q9.68485 3.29104 9.59481 3.25113Q9.50476 3.21122 9.42424 3.15452Q9.28232 3.05458 9.18238 2.91266Q8.55925 2.02778 7.60558 1.52176Q6.62228 1 5.5 1ZM5.5 -1Q7.12002 -1 8.54302 -0.244943Q9.91913 0.485243 10.8176 1.76114L10 2.3369L9.18238 1.76114Q10.0809 0.485243 11.457 -0.244943Q12.88 -1 14.5 -1Q15.8218 -1 17.0304 -0.488784Q18.197 0.00467104 19.0962 0.903812Q19.9953 1.80295 20.4888 2.9696Q21 4.17825 21 5.5Q21 7.69503 19.8144 9.94525Q18.804 11.863 17.0231 13.6615Q15.4635 15.2365 13.5852 16.4612Q11.8203 17.612 10.3154 18.1121Q10.1618 18.1631 10 18.1631Q9.83819 18.1631 9.68464 18.1121Q8.17972 17.612 6.41476 16.4612Q4.53647 15.2365 2.97692 13.6615Q1.19604 11.863 0.185601 9.94525Q-1 7.69503 -1 5.5Q-1 4.17825 -0.488787 2.96961Q0.00466634 1.80295 0.903806 0.903813Q1.80295 0.0046704 2.9696 -0.488784Q4.17824 -1 5.5 -1Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 2 4)"
          fill={isFavorite ? "rgb(250, 94, 31)" : "rgb(255, 255, 255)"}
        />
      </g>
    </svg>
  );
};

export default TvFavoriteIcon;
